import {
    isLoadingProjects,
    getDefaultProjectLoadState,
    DefaultProjectLoadState,
} from 'owa-timestream-store';
import getDefaultBoardProject from './getDefaultBoardProject';

/**
 * Checks if the default calendar board project has loaded.
 * NOTE: this is used to display the board FRE dialog when a user has existing projects but no
 * default board project.
 * @returns true if the default calendar board has loaded, false otherwise.
 */
export default function hasLoadedDefaultBoardProject(): boolean {
    if (isLoadingProjects()) {
        return false;
    }

    return (
        !!getDefaultBoardProject() ||
        getDefaultProjectLoadState() === DefaultProjectLoadState.SuccessCreateNew
    );
}
